import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_PRODUCT_NOTES: string = typeCreatorV2(
  'ProductNotesReducer',
  'SetProductNotes'
);

export const CREATE_NOTE: string = typeCreatorV2(
  'ProductNotesReducer',
  'CreateNote'
);

export const DELETE_NOTE: string = typeCreatorV2(
  'ProductNotesReducer',
  'DeleteNote'
);
